export default __webpack_public_path__ + "static/media/Exploritory.038a1db7.svg";